import {apiPost, API_URL} from '../api'

interface ICreateAd {
    title: string
    thumbnail: string
    description?: string
    pc_url?: string
    mobile_url?: string
    language: string
    is_active: boolean
}

export const createAdvertisement = async data => {
    return await apiPost(API_URL, 'admin/ad', data)
}
